import { render } from "./IconPaperPlaneSolid.vue?vue&type=template&id=2a3fb5ec"
const script = {}
script.render = render

export default script